import React from 'react'

import { Form, Table } from '_zari/core'

const FilaDetalleTemplate = ({ index, row, actualizarFilaHandler, eliminarFilaHandler }) => {
  const [cantidad, setCantidad] = React.useState(row.cantidad)

  const keyUpCantidadHandler = e => {
    const keyCode = e.keyCode

    let __focusCantidad = true
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      __focusCantidad = false
      saltarFila = true
      saltarCampo = true
    }

    actualizarFilaHandler({
      ...row,
      cantidad,
      __focusCantidad,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownCantidadHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const clickEliminarFilaHandler = () => {
    window.setTimeout(() => {
      eliminarFilaHandler(row._idFila)
    }, 150)
  }

  const inputCantidadRef = React.useRef()
  React.useEffect(() => {
    if (row.__filaActiva && row.__focusCantidad) {
      window.setTimeout(() => {
        inputCantidadRef.current.select()
      }, 250)
    }
  }, [row.__filaActiva, row.__focusCantidad])

  return (
    <>
      <tr>
        <td>{parseFloat(index) + 1}</td>
        <td>{row.codigoProducto || '--'}</td>
        <td>{row.nombreProducto || '--'}</td>
        <td>
          <Form.InputNumber
            ref={inputCantidadRef}
            placeholder='0'
            value={cantidad}
            onChange={e => setCantidad(e.target.value)}
            onKeyUp={keyUpCantidadHandler}
            onKeyDown={keyDownCantidadHandler}
          />
        </td>
        <td>{row.nombreUnidadDeMedida || row.unidadMedida || '--'}</td>
        <td>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item
                key='eliminar'
                handleClose={handleClose}
                onClick={clickEliminarFilaHandler}
              >
                Eliminar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </td>
      </tr>
    </>
  )
}

export default React.memo(FilaDetalleTemplate)
